import React from "react";
import { HashRouter, Route, Routes, useLocation, Navigate } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import Ticket from "./Pages/Ticket";
import { pageTransition } from "./common/motionVariants";

const AnimatedPage = ({ children }) => (
  <motion.div
    initial={pageTransition.initial}
    animate={pageTransition.animate}
    exit={pageTransition.exit}
  >
    {children}
  </motion.div>
);

const AnimatedRoutes = () => {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<AnimatedPage><Ticket /></AnimatedPage>} />
        <Route path="/Ticket" element={<AnimatedPage><Ticket /></AnimatedPage>} />
        <Route path="*" element={<Navigate to="/Ticket" replace />} />
      </Routes>
    </AnimatePresence>
  );
};

const Main = () => {
  return (
    <HashRouter>
      <AnimatedRoutes />
    </HashRouter>
  );
};

export default Main;
